"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPage = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var react_redux_1 = require("react-redux");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Message_1 = require("@/pages/common/components/Message");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Sbar_1 = require("@/pages/search/components/Sbar");
var Results_1 = require("@/pages/search/components/Results");
var Contact_1 = require("@/pages/common/components/contact/Contact");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var SaveSearchDialog_1 = require("@/pages/search/components/SaveSearchDialog");
var Enquire_1 = require("@/pages/common/components/Enquire");
var Login_1 = require("@/pages/common/components/Login");
var Signup_1 = require("@/pages/common/components/Signup");
var Recapture_1 = require("@/pages/search/components/Recapture");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var CallOrEmail_1 = require("@/pages/common/components/CallOrEmail");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var SearchMap_1 = require("@/pages/search/components/SearchMap");
var SearchMapList_1 = require("@/pages/search/components/SearchMapList");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var format_1 = require("@/utils/format");
var Hfilter_1 = require("@/pages/search/components/Hfilter");
var Fbar_1 = require("@/pages/search/components/Fbar");
var HfilterFull_1 = require("@/pages/search/components/HfilterFull");
var SearchQueryAction_1 = require("@/pages/search/actions/sfilter/SearchQueryAction");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var HfilterSort_1 = require("@/pages/search/components/HfilterSort");
var ApplyFilter_1 = require("@/pages/search/components/ApplyFilter");
var Dinfo_1 = require("@/pages/search/components/Dinfo");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { mapInit: state.mapsearch.mapInit, hasBoundary: state.results.isMap, symbol: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol })); };
var mapDispatchToProps = function (dispatch) { return ({
    onSetHideMap: function (state) {
        return dispatch(SearchMapAction_1.default.onSetHideMap(state));
    },
    search: function () { return dispatch(SearchQueryAction_1.default.search()); },
    resetMap: function () { return dispatch(SearchMapAction_1.default.resetMap()); },
    onFilterPanelBackgroundClick: function () { return dispatch(HfilterAction_1.default.onFilterBackgroundClick()); },
    onShowMapClick: function () { return dispatch(HfilterAction_1.default.setMapActive(true)); },
    onHideMapClick: function () { return dispatch(HfilterAction_1.default.setMapActive(false)); },
}); };
exports.searchPage = function (props) {
    var isHfilterActive = props.hfilter.listingTypeActive ||
        props.hfilter.districtActive ||
        props.hfilter.priceActive ||
        props.hfilter.sizeActive ||
        props.hfilter.bedsActive ||
        props.hfilter.propertyTypeActive ||
        props.hfilter.amenityActive ||
        props.hfilter.keywordActive;
    var appClasses = classnames_1.default('l-search', 'c-nav--safari', {
        'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
        'c-nav__menu-setting--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
        'l-search--mtab': props.layout.activePanel === LayoutState_1.ActivePanel.FAV,
        'l-hfilterfull--filter-active': props.hfilter.filterFullActive,
        'c-calloremail--active': props.layout.callOrEmailActive,
        'l-search--map': props.hfilter.mapActive,
        'l-search--filter': isHfilterActive,
        'l-hfilterfull--district-active': props.hfilter.fullDistrictActive
    });
    var loadingClass = classnames_1.default([
        'l-arch__loading',
        {
            'l-arch__loading--active': props.layout.isLoading,
        },
    ]);
    var topmenuClass = classnames_1.default([
        'l-search__nav',
        { 'l-search__nav--alert': props.user.email && !props.user.isConfirmed },
    ]);
    var renderLoading = function () {
        return (React.createElement("div", { className: "c-loading " + (props.results.isLoading ? 'c-loading--active' : '') },
            React.createElement("div", { className: "c-loading__balls" },
                React.createElement("div", { className: "c-loading__ball-1" }),
                React.createElement("div", { className: "c-loading__ball-2" }))));
    };
    var renderEstateCard = function () {
        var renderImage = function () {
            return props.results.estateImage ? (React.createElement("a", { href: props.results.estateUrl, className: "c-estatecard__img" },
                React.createElement("img", { src: props.results.estateImage }))) : null;
        };
        var renderPpsf = function () {
            if (!props.results.estatePpsf)
                return;
            return (React.createElement("div", { className: "c-estatecard__ppsf" },
                React.createElement("span", { className: "c-estatecard__ppsf-value" }, format_1.default.currencyFull(props.results.estatePpsf, props.symbol)),
                React.createElement("span", { className: "c-estatecard__ppsf-unit" },
                    "\u00A0",
                    props.results.t.persf,
                    "(",
                    props.results.estateIsSa ? props.results.t.saleable : props.results.t.gross,
                    ")")));
        };
        return !props.results.isLoading && props.results.estateName ? (React.createElement("div", { className: "c-estatecard" },
            React.createElement("div", { className: "c-estatecard__body" },
                renderImage(),
                React.createElement("div", { className: "c-estatecard__info" },
                    React.createElement("a", { href: props.results.estateUrl, className: "c-estatecard__title" }, props.results.estateName),
                    React.createElement("a", { href: props.results.estateUrl, className: "c-estatecard__address" },
                        React.createElement("span", { className: "fal fa-map-marker-alt" }),
                        "\u00A0",
                        props.results.estateAddress),
                    renderPpsf(),
                    React.createElement("div", { className: "c-estatecard__actions" },
                        React.createElement("a", { href: props.results.estateUrl, className: "o-btn o-btn--primary" },
                            props.results.t.viewMore,
                            React.createElement("span", { className: "fal fa-external" }))))))) : null;
    };
    var onMapToggleClick = function () {
        var mapToggleAction = props.hfilter.mapActive ? props.onHideMapClick : props.onShowMapClick;
        return mapToggleAction();
    };
    return (React.createElement("div", { className: appClasses },
        React.createElement("div", { className: loadingClass },
            React.createElement("div", null,
                React.createElement("span", { className: "fal fa-sync u-rotate" }))),
        React.createElement(Message_1.default, null),
        React.createElement("div", { className: topmenuClass },
            React.createElement(MegaMenu_1.default, null)),
        React.createElement("div", { className: "l-search__overlay" },
            React.createElement("div", { className: "l-search__views" },
                React.createElement(Hfilter_1.default, null)),
            React.createElement("div", { className: "l-search__sbar" },
                React.createElement(Sbar_1.default, null)),
            React.createElement("div", { className: "l-search__overlay-main" },
                React.createElement("div", { className: "l-search__sidebars" },
                    React.createElement("div", { className: "l-search__main" }),
                    React.createElement("div", { className: "l-search__map" }, props.mapInit ? (React.createElement(SearchMap_1.default, null)) : null),
                    React.createElement("div", { className: "c-maptoggle" },
                        React.createElement("span", { className: "c-maptoggle__btn", onClick: onMapToggleClick },
                            React.createElement("span", { className: "c-maptoggle__btn-text c-maptoggle__btn-text--map" },
                                React.createElement("span", { className: "fal fa-map" }),
                                "\u00A0",
                                React.createElement("span", null, props.hfilter.t.showMap)),
                            React.createElement("span", { className: "c-maptoggle__btn-text c-maptoggle__btn-text--close" },
                                React.createElement("span", { className: "fal fa-times" }),
                                "\u00A0",
                                React.createElement("span", null, props.hfilter.t.closeMap))))),
                React.createElement("div", { onClick: props.onFilterPanelBackgroundClick, className: "l-search__hfilter-bg" }))),
        React.createElement(HfilterFull_1.default, null),
        React.createElement(HfilterSort_1.default, null),
        React.createElement("div", { className: "l-search__body" },
            React.createElement(Fbar_1.default, null),
            React.createElement("div", { className: "l-search__results-search" },
                props.results.isLoading ? null : renderEstateCard(),
                React.createElement(Results_1.default, null),
                React.createElement(Dinfo_1.default, null),
                React.createElement(Contact_1.default, null),
                React.createElement(Megafoot_1.default, null),
                renderLoading())),
        React.createElement("div", { className: "l-search__list" },
            React.createElement(SearchMapList_1.default, null)),
        React.createElement(SaveSearchDialog_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(Recapture_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(Signup_1.default, null),
        React.createElement(ExistingLogin_1.default, null),
        React.createElement(CallOrEmail_1.default, null),
        React.createElement(ServerSideSchema_1.default, null),
        props.hfilter.hasUnsaved ? React.createElement(ApplyFilter_1.default, null) : null));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.searchPage);
